const getRulesetsResponse = (response) => {
  return response?.scheduleRulesets.map((ruleset) => {
    return {
      ...ruleset,
      isDisabled: !ruleset.isAvailable,
      value: ruleset.id,
      label: ruleset.accountLivestreams
        .map((account) => {
          return `${account.name} ${account.platform}`;
        })
        .join(', '),
    };
  });
};

export default getRulesetsResponse;
